import requests from "./httpService";

const ScheduleServices = { 
  getAllSchedule: async () => {
    return requests.get("/schedule/all");
  }, 

  getScheduleById: async (id) => {
    return requests.get(`/schedule/${id}`); 
  },

  addSchedule: async (body) => {
    return requests.post("/schedule/add", body); 
  },

  updateSchedule: async (id, body) => {
    return requests.put(`/schedule/${id}`, body); 
  },
 
  updateScheduleStatus: async (id, body) => {
    return requests.put(`/schedule/status/${id}`, body); 
  },

  deleteSchedule: async (id, body) => {
    return requests.delete(`/schedule/${id}`, body);
  },  

};

export default ScheduleServices; 
